module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectLayout-1a"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/htp.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Also By Jerry Scott and Jim Borgman")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Zits: Sketchbook 1")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Growth Spurt: Zits Sketchbook 2")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Don’t Roll Your Eyes at Me, Young Man!: Zits Sketchbook 3")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Are We an “Us”?: Zits Sketchbook 4")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Zits Unzipped: Zits Sketchbook 5")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Busted!: Zits Sketchbook 6")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Road Trip: Zits Sketchbook 7")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Teenage Tales: Zits Sketchbook No. 8")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Thrashed: Zits Sketchbook No. 9")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Pimp My Lunch: Zits Sketchbook No. 10")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Are We Out of the Driveway Yet?: Zits Sketchbook No. 11")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Rude, Crude, and Tattooed: Zits Sketchbook No. 12")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Jeremy and Mom")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Pierced")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Lust and Other Uses for Spare Hormones")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Jeremy & Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("You’re Making That Face Again")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Drive!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Triple Shot, Double Pump, No Whip Zits")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Zits en Concert")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Peace, Love & Wi-Fi")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Treasuries")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Humongous Zits")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Big Honkin’ Zits")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Zits: Supersized")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Random Zits")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Crack of Noon")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Alternative Zits")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("My Bad")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Sunday Brunch")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Gift Book")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("A Zits Guide to Living with Your Teenager")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1ba"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/title.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("To Nanci and Paul, for helping to make the world a better place for kids.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("—J.S.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("To George and Kathy, with thanks for helping to make this home.")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("—J.B.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.1.5comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" One of my favorite devices is to show Jeremy’s brain as a character. It’s like the Joe Cool of vital organs.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" It tests one’s patience, doesn’t it, explaining the obvious to parents?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.1.12comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" A little hand for the colorist here, ladies and gentlemen?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer017"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer018"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD CharOverride-4"
  }, [_vm._v("Jim:")]), _vm._v(" Pierce’s tattoos are infinitely flexible in "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zit")]), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("s")]), _vm._v(". If the joke calls for it, his body is covered in them; when that’s not the joke, his skin is pure as the driven snow. I learned the elasticity of the cartoon universe by watching "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("The Simpsons")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer020"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer021"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" My daughter’s bio-chem homework was lying around and I saw the words “intercellular communication,” which made me think of the idea for this strip. And now you know what my grades must have been like in school.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer022"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Comic strips can be a haven from the world’s tougher issues, but sometimes our characters should have to deal with the same crunches as the rest of us.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer024"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer025"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" It occurred to Jim and me that Jeremy has led a fairly privileged life, and we thought it was time to inject some good old financial reality into his life . . . to the extent he’s able to accept reality.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer023"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer026"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" It’s a subtle thing, but we decided the Duncans should bring their own bags to the grocery store from now on.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer027"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.1.19comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer029"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer030"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" It's hard to create band names that aren’t actually out there in the real world. If we think we’ve made up a good one, we try not to Google it. It only leads to disappointment.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer032"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer033"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I rented an apartment once on a vacation that came with wi-fi. The password was written on an instruction sheet, and it had—I am not kidding—fifty-four letters, ligatures, punctuation marks, and symbols (American and European). I was finally able to log onto the Internet the day before we left to go home.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer031"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer034"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" White space is underrated in the comics. It’s nice to give the readers’ eyes a rest once in a while.    ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer036"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer035"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer037"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.1.26comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer038"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Another touching moment of male bonding.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer040"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer041"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Existential "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" question: Why does this kid always have a roomful of dirty laundry despite wearing the same thing every day?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer039"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer043"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer042"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer044"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" So I have a thing for Sylvia Poggioli. Don’t judge me.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer046"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.1.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer045"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer047"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Who needs layers when they’re built in?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer048"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.2.2comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer049"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" A perk of being a cartoonist is that you get to insert your friends into strips like this. I get a lot of free meals this way.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer051"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer052"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Dad’s body is ink-intensive.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer050"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer053"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I always struggle to draw Mom and Dad as younger parents. I can slap some hair on Dad, but Mom doesn’t look like herself with any other 'do.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer055"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer056"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I have nothing more to add to this strip, except to say that I wish kids really did come with flip-top heads for easy cleaning.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer054"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer058"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer059"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" The way Jeremy chomps into a chicken leg in panel #2, and then tosses the bare bone away in panel #3, is comic strip shorthand to show the passage of time between panels and to reinforce an aspect (perpetual hunger) of Jeremy’s personality. End of cartooning lesson. You’re excused.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer057"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer060"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.2.9comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer061"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Jeremy has more insecurities than this, but they only give us so much space.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer063"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer064"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" This is my view, but I’ve since been informed by a whole lotta’ Dumb Hipster Hat Wearers that I am wrong. Who knew the DHHW could be so touchy?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer062"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer065"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" For more on Grandma, read our novel "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits Shredded")]), _vm._v(". She is quite the piece of work.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer067"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.26._wash_post_edit.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer068"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Believe it or not, the babe in panel #1 actually caused one newspaper editor to refuse to print this strip. Despite the fact that she’s tamer than ads that run on that newspaper’s own website.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer066"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer069"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I hate it when salads cause your hair to burst into flames, don’t you?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer071"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.2.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer072"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Dad's eyes are so funny when he takes his glasses off. I have no idea why.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer070"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer073"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I was standing in a movie theater lobby waiting for my wife to come out of the bathroom. I must have stood in one place too long, because when I turned to follow her out of the theater, the sugar weld between my right shoe and the concrete floor refused to give. I miss that shoe.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer074"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.2.16comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer076"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer075"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer077"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" In my town they called off school once on account of cold. I think they were afraid all those boys who come to school in shorts all winter would freeze to death.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer079"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer078"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer081"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer080"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer082"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.2.23comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer084"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer083"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer087"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer085"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" It seems like almost all of the commercials during the news are filled with cures for horrifying maladies of old age, followed by the even more horrifying side effects of those cures. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer086"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer088"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Comic strip cussing is do-it-yourself. We provide the symbols, you fill in the words of your choice.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer090"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer091"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Skim-listening is a critical skill, guys. Master it now and save your sanity.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer089"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer092"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.3.16comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer094"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer095"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" A Full-Mom volume setting would just be dangerous . . . and illegal within city limits.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer093"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer097"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer096"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer099"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer098"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer100"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Jerry loves to give our characters something visual to do while they talk. Draping Jeremy over the chair while he texts would not have occurred to me, but it’s natural and funny when you see it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer101"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.3.23comp1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer103"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer104"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Being a parent of a teenager requires getting used to missing most cultural references your kid throws out there.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer102"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer106"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer105"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer107"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Me: “Hey, let’s have Pierce making lattes on a $10,000 Italian espresso machine in class and have it seem perfectly normal.” ")]), _vm._v(" "), _c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" “Okay.” Man, I love making comic strips!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer109"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer108"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer110"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.3.30comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer112"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.3.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer113"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" He has seen the future, and it wears sensible walking shoes.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer111"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer115"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer114"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer116"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Then again, it’s kind of nice to be “liked” while you’re sound asleep.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer117"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/page50.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer119"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer120"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Jeremy has 9,723 ways of resting on a chair, and none of them involve having his feet on the floor.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer118"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer122"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer123"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Anything crunchy, salty, and orange is usually good.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer121"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer125"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer126"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" The van is the most overlooked character in our cast. It has as much personality as anyone in the strip.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer124"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer127"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" What’s more uncomfortable than talking about personal hygiene with your mom? The CIA should add it to their interrogation tool box.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer129"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer128"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer130"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.4.6comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer131"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Anytime you get the chance to put Wilma and Fred in a strip, you do it. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer133"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer132"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer135"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer136"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" When we get in a “talking head” rut, I ask Jerry to give me something fun to draw. Sometimes I give him a bunch of images I’d enjoy drawing and those occasionally inspire strip ideas like this one.")]), _vm._v(" "), _c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" “Hey Jerry, think of a strip idea involving the flying monkeys from "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Wizard of Oz")]), _vm._v(".” And you think YOUR job is hard?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer134"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer138"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer137"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer139"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.4.20comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer140"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We pride ourselves on populating a lively stage in "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(". This middle panel is pretty much what we live for.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer142"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer143"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" My stepson Jake is the quiet inspiration behind a bunch of "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" strips. He and his college roommate once considered competitive eating as an income stream.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer141"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer145"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer144"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer146"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We should revisit the image of Dad on a Segway. They seem made for each other.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer148"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer149"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" You can say it with words, or say it with pictures. I choose pictures whenever possible.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer147"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer150"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We haven’t nailed down precisely where the Duncans live, but it’s somewhere in the Midwest and it frequently looks like Cincinnati, where I grew up. Dad can often be spotted in a Reds baseball cap.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer151"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.4.27comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer153"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer154"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I love Mom’s occasional bursts of sarcasm.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer152"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer155"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" In the van’s case, missing parts are more likely to improve performance than harm it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer157"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.4.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer156"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer159"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer158"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer160"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I wonder if they emphasize the importance of good nostril hair grooming in orthodontia school?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer161"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.5.4comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer163"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer162"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer165"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer166"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Peace, Love & Wi-Fi")]), _vm._v(" is the title of our previous "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" collection book. We came up with it during a brainstorming session. We liked it so much that I reverse-engineered it into a strip.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer164"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer168"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer169"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We’ve never met Pierce’s dad in the strip. I cannot imagine what that man has been through.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer167"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer170"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I bet we could sell these.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer171"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.5.11comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer172"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Jeremy is stretchier than Gumby.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer174"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer173"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer176"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer177"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" The bigger Mom’s frustration with Jeremy, the more I like it. The poor woman.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer175"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer179"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer180"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" That should be the theme for every prom. Wouldn’t the decorating committees have a ball?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer178"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer181"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.5.18comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer183"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer184"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Kids. Am I right?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer182"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer185"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Possibly the best of our Mom/wrinkle strips. Who’s with me?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer187"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer188"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" There’s tragic, and then there’s TRAGIC.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer186"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer190"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer189"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer191"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" The roof outside his room is Jeremy’s place for big thoughts. It’s our equivalent of Snoopy musing on top of his doghouse.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer192"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.5.25comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer193"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" We debated over the things the phone should be doing in this strip for a couple of hours. Yeah, two grown men deciding whether octopus tentacles or lava best represents a threatening text.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer195"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer194"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer197"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer198"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Disturbing anatomy is forgivable in the service of a good joke, I think we can all agree.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer196"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer200"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer201"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Reality sometimes outpaces satire. We heard from several readers who buy clothes this way.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer199"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.5.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer202"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Parents. Am I right?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer203"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.6.1comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer205"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer204"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer207"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer208"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Hector has always been the most mature kid in the strip. But given the rest of the characters, that’s not saying much.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer206"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer209"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I like my pepperoni cholesterol-injected and nature-free. But that’s just me.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer211"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer212"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Check your color wheels. ROYGBIV, everybody!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer210"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer213"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p88.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer214"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Moms love these Little Jeremy strips. Wasn’t he a cutie?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer216"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer217"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Who am I to talk? Jerry and I sometimes text each other while we’re on the phone talking to each other.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer215"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer219"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer220"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I have personally seen this strip posted on refrigerators in the homes of three different friends.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer218"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer222"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer223"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I think I speak for teenagers everywhere when I say, “Eww.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer221"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer224"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.6.15comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer225"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Girls contain so much more readily accessed information than guys.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer227"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer226"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer229"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer230"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Well, that’s what it seems like to me.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer228"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer231"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" The # is technically called an octothorpe, but that isn’t particularly funny.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer233"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer234"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Lawns. Am I right?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer232"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer235"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.6.22comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer237"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer238"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Schedules devolve during the summer. By late June they’re primordial ooze.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer236"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer239"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD CharOverride-4"
  }, [_vm._v("Jerry:")]), _vm._v(" Pierce is a joy to write for. He’s so enigmatic that nearly any outlandish thing he does seems plausible . . . including enjoying a conversation with Jeremy’s mom.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer241"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer240"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer242"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I frequently use that zigzag pattern on lamps and bowls in "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v("—it’s a nod to Charlie Brown’s sweater and a quiet homage to one of the greats, Charles Schulz.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer244"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer243"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer245"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.6.29comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer247"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.6.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer248"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" This series happened as the result of my daughter ruining her umpteenth cell phone. "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" is therapy that also pays my mortgage.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer246"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer250"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer249"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer251"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" A good offer is a good offer.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer253"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer254"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" One of the keys to being a cartoonist is having funny friends. I owe this idea to my buddy Tom DeVoge, whose quick mind served up this gem.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer252"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer255"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.7.6comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer256"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I want one of these.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer258"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer259"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Duh.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer257"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer261"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer260"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer262"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p108.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer264"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer265"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Maybe we should change the term “summer vacation” to something more accurate. Like, “summer bug-your-kid-to-do-something-useful time.”")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer263"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer266"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Does anything elicit human sympathy more than the sight of a sign-twirling kid working for minimum wage in a hot smelly costume on the blistering  sidewalk of a strip mall on a summer day? I think not.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer268"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer267"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer269"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" This is not based on anyone I know or am married to. Nope.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer271"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer270"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer273"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer274"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" When Jeremy’s not wearing that purple checked shirt, he’s usually in this T-shirt. I designed it to look current but unintelligible, and I think he pulls it off.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer272"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer275"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Any excuse to draw zombies.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer276"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.7.20comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer278"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer279"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I have been told that "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" holds the record for most strips taped on laundry room walls. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer277"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer281"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer280"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer283"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer284"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" But for lack of a bucket of paint and a twenty-foot blank wall, I’d have done this a hundred times.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer282"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer285"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Take a moment and just look at the way Jim draws Jeremy’s room. Beauty. Can there be any doubt that he had a teenage son for a time?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer286"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.7.27comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer288"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer287"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer290"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer291"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" This joke was shamelessly stolen from a sign in a technology store. Thank you, anonymous store employee.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer289"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.7.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer292"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I’m fond of the action here. Boy, does Dad look heavy on that couch in panel three!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer294"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer295"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" “SPANG” is an underused sound effect. Try it on a friend today.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer293"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer296"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.3comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer298"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer299"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I hate to tell you how much grief we took over this series from a certain bizarre individual who runs a ferret anti-defamation organization. When we Googled the guy, it turned out he had driven many prominent civic leaders crazy in his quest to defend the reputations of ferrets everywhere.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer297"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer301"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer300"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer303"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer304"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" This was the strip that sent the ferret guy to his keyboard. He claims that we somehow inferred that ferrets could be aggressive. Feh.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer302"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer305"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.10comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer307"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer306"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer309"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer310"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I’ll get rid of my landline when they make cell phone calls sound clearer than my daughter’s $6 Radio Shack walkie-talkie.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer308"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer312"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer313"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" People ask me if I’m Dad. I will only admit to feeling very comfortable when he is onstage.")]), _vm._v(" "), _c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" The idea for the punchline in this strip came from my niece, Lindsay, who delivered it with painful accuracy to my midsection.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer311"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer314"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Actual names. You could look it up.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer315"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.17comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer316"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Maybe there’s such a thing as too much positive reinforcement.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer318"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer317"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer319"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" How many squids have given their last ounce of ink to drawings of this kid’s messy room?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer321"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer322"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Every concert I go to these days has an audience that looks like the one at this one. Geez.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer320"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer324"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer325"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Just for the record, dishwashers are haaarrrrrd to draw. When you see one in "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(", how about a little hand?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer323"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer326"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.24comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer327"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" This was inspired by a story I heard on NPR. A child was asked why he prefers to stay indoors rather than play outside. “Because,” he said, “the electric outlets are inside.” ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer329"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer328"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer330"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Word-for-word, device-for-device, attitude-for-attitude, right out of my living room.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer332"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer331"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer334"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer335"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I can only guess that Jerry does a lot of his writing in coffee shops. He keeps sending me these ideas with various antique espresso machines in them.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer333"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.8.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer336"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Just Your Mom would be a great name for a band.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer337"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.8.31comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer339"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer338"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer341"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer340"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer342"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Sweet. Creepy, but sweet.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer344"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer343"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer345"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" To be clear . . .")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer346"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.9.7comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer348"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer347"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer349"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Feet . . . Legs . . . Backpacks . . . they’re making them all bigger these days.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer351"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer350"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer353"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.9.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer354"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" It makes writing the blues so much harder.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer352"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer355"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Ouch. Harsh. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer356"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.9.14comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer358"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer359"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" One of my favorite punchlines in the history of "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(". It echoes in my head whenever I realize I’ve slipped behind the times again.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer357"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer361"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer360"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer363"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer362"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer364"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I got a text from my daughter inviting my wife and me out to an early breakfast on a weekend . . . at 11 a.m.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer365"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.9.21comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer366"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Those birds that sit on rhinos are called oxpeckers, but we decided not to test the editors by putting the word in the strip.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer368"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer369"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Dad on air guitar is always good for a cheap laugh.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer367"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer370"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" In desperate deadline situations, sometimes I’ll try rewriting old axioms. This one worked.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer372"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer373"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We get occasional comments from readers to the effect that Jeremy is too rude to his parents. I can’t say that I always disagree. Somebody should put that kid in his place.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer371"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer374"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.9.28comp.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer376"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer375"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.9.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer378"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer379"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" A friend’s family inspired this series. Sometimes they would walk the halls of their house before getting in bed just to out-step another family member for the day. This is a level of competitiveness with which I am unacquainted.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer377"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer381"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer380"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer383"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer382"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer384"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.10.19comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer385"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I sent Jerry a page from my sketchbook containing the first four panels of this Sunday strip. He wrote the rest. Jerry has a genius for finding a joke where I can’t see one.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer387"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer386"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer389"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer388"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer390"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Minimum verbiage, maximum inkage.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer392"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer391"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer393"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.10.26comp.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer394"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Bad moods and how to handle them—a primer.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer396"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer397"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Sometimes strip ideas come from random sketchbook doodles, but I think these came from me making faces in the mirror.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer395"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer399"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer398"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer401"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.10.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer400"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer402"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.11.2comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer403"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" I had a lot of T-shirt real estate to manage in this strip, so I lettered on the names of Bruce Springsteen’s old bands just for grins. A little postcard to my fellow Bruceophiles.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer405"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer406"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" We were in the mood for some one-panel, long-nose strips, so, yeah.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer404"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer408"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer407"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer410"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.7.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer409"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer411"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" David Sedaris, one of my favorite writers has a book titled "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Me Talk Pretty One Day")]), _vm._v(", which inspired this punchline. “Inspired”. . . that’s what you call it when you steal stuff sort of accidentally, right?")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer412"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.11.9comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer414"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer415"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" That dude in the beanie shows up a lot in the high school hallways. But I’m thinking his name is Manfred.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer413"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer416"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" I Googled “math equations” for all the cool little math-y symbols in this strip.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer418"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer417"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer420"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.14.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer421"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Another line from the Book of Jake.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer419"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer422"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.11.16comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer424"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer425"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Basketball shorts get the prize for most-enlarged athletic uniform.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer423"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer427"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer428"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" A different kind of joke for us. There isn’t really a punchline here. More like a slice of life that’s funny when you look at it a certain way.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer426"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer430"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.21.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer429"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer431"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Inspired by "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("The Fault in Our Stars")]), _vm._v(". John Green rules!")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer432"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.11.23comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer434"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer435"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" There's that wayward brain again.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer433"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer436"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" My wife convinced me to take her on a trip to Paris a couple of years ago. The negotiation went something like this.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer438"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer437"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer439"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" That, my friends, is a lot of funny to pack into a very small space.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer441"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.28.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer440"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.11.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer442"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/p185.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer444"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer445"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" We wrestle to keep "), _c('span', {
    staticClass: "italics _idGenCharOverride-2"
  }, [_vm._v("Zits")]), _vm._v(" current without trying to ride every passing trend. Is Jeremy’s clothing still viable as the years go by? The big shoes? The baggy jeans? We decided to acknowledge changing styles in this series.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer443"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer447"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer446"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.4.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer448"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" We got a lot of positive feedback on the drawing of Jeremy in his skinny jeans. The term, “flannel hors d’oeuvre” makes me thirsty every time I read it.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer450"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.5.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer449"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.6.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer452"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.8.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer451"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.9.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer454"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.10.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer453"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.11.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer455"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" The sales clerk is a subtle thank you to my daughter Chelsea who helped envision this series. As a matter of fact, almost any curly-haired character in the strip is drawn with her in mind.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer457"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.12.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer458"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Aaaaand we’re back.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer456"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.13.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer459"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.12.7_comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer460"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.12.14comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer461"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" Not the worst idea I’ve heard for a snow day.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer463"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.15.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer464"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jery:")]), _vm._v(" The smartphone could be the new #1 cause of household mishaps.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer462"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.16.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer466"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.17.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer465"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.18.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer467"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.12.21comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer468"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jim:")]), _vm._v(" There’s an editor at our syndicate who tries to read every word of these verbiage mash-ups to make sure we’re not trying to slip something inappropriate onto the comics page. I love making her life as hard as possible.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer470"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.19.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer469"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.20.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer472"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.22.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer471"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.23.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer474"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.24.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer475"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Okay, yeah, I want one. The people at Gibson Guitars didn’t get the memo, though.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer473"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.25.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer476"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Blame the World Ethics class.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer478"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.26.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer479"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Yoga is my exercise of choice, as long as there are no large mirrors present.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer477"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.27.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer480"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ZITS14.12.28comp.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer482"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.29.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer481"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.30.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer484"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits14.12.31.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer485"
    }
  }, [_c('p', {
    staticClass: "Annotation"
  }, [_c('span', {
    staticClass: "BOLD _idGenCharOverride-1"
  }, [_vm._v("Jerry:")]), _vm._v(" Mom’s “Lunchtime!” line nailed this strip for me.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer483"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits15.1.1.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer487"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits15.1.2.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer486"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/zits15.1.3.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1ba"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer488"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ApocalypseSpotArt.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer490"
    }
  }, [_c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Zits")]), _c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("®")]), _c('span', {
    staticClass: "CharOverride-9"
  }), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("is syndicated internationally by King Features Syndicate, Inc. "), _c('br'), _vm._v("For information, write King Features Syndicate, Inc., 300 West Fifty-Seventh Street, "), _c('br'), _vm._v("New York, New York 10019.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Zits Apocalypse")]), _c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v(" copyright © 2015 by Zits Partnership. All rights reserved.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Andrews McMeel Publishing, LLC")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("an Andrews McMeel Universal company")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("1130 Walnut Street, Kansas City, Missouri 64106")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "Hyperlink CharOverride-10"
  }, [_vm._v("www.andrewsmcmeel.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("ISBN: 978-1-4494-7451-5")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Library of Congress Control Number: 2015937246"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-11"
  }, [_vm._v("Attention: Schools and Businesses")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal ParaOverride-3"
  }, [_c('span', {
    staticClass: "CharOverride-9"
  }, [_vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for "), _c('br'), _vm._v("educational, business, or sales promotional use. For information, please e-mail the "), _c('br'), _vm._v("Andrews McMeel Publishing Special Sales Department: specialsales@amuniversal.com.")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer489"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("zitscomics.com • facebook.com/zitscomics • twitter.com/therealzits • rockgod99.tumblr.com ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b11cd68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZITSapocalypse_EPUB.vue
// module id = 60
// module chunks = 0